import '@/utils/rum';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.css';

import type { InfinexEnvironment } from '@infinex-private/connect-types';
import { configureWebShared } from '@infinex/web-shared/config';

import App from './App';
import { initializeClients } from './lib/client';
import { envVars, WORKER_MAIN_PROXY_PATH } from './lib/environment/config';
import { initEnv } from './lib/environment/utils';
import { createMutationHook, createQueryHook } from './lib/queryHookFactory';

initEnv();

const { client, apiClientV2, trpcClientV2 } = initializeClients();

// Configure web-shared to use our client instance
configureWebShared({
  environment: envVars.INFINEX_ENVIRONMENT as InfinexEnvironment,
  workerMainUrl: WORKER_MAIN_PROXY_PATH,
  assetActionsBaseUrls: {
    swidge: '/swidge',
    move: '/move',
    sendWallet: '/portfolio/wallet/send',
    sendVault: '/portfolio/vault/send',
  },
  api: {
    client,
    createQueryHook,
    createMutationHook,
  },
  apiV2: apiClientV2,
  trpcClientV2,
  sessionKeyUserType: 'operation',
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
